export const commonStateStyles = (FOUNDATIONS, FONT, STATE_TOKENS) => ({
    ...STATE_TOKENS,
    container: {
        position: 'relative',
        display: 'inline-flex',
        align_items: 'center',
        ...STATE_TOKENS.container,
    },
    checkbox: {
        cursor: 'pointer',
        display: 'grid',
        height: FOUNDATIONS.size_300,
        width: FOUNDATIONS.size_300,
        border_style: 'solid',
        border_radius: FOUNDATIONS.radius_comp_forms_checkbox_radiussize,
        border_width: FOUNDATIONS.border_50,
        border_color: FOUNDATIONS.color_neutral_border_150,
        focusVisible: {
            outline: 'none',
            box_shadow: `0 0 ${FOUNDATIONS.blur_00} ${FOUNDATIONS.spread_50} ${FOUNDATIONS.color_effect_focus_50}, 0 0 ${FOUNDATIONS.blur_00} ${FOUNDATIONS.spread_100} ${FOUNDATIONS.color_effect_focus_100}`,
        },
        ...STATE_TOKENS.checkbox,
    },
    checkedIconContainer: {
        display: 'none',
        pointer_events: 'none',
        position: 'absolute',
        background_color: 'transparent',
        ...STATE_TOKENS.checkedIconContainer,
    },
    checkedIcon: {
        height: FOUNDATIONS.size_300,
        width: FOUNDATIONS.size_300,
        color: FOUNDATIONS.color_accent_selected_icon_50,
        ...STATE_TOKENS.checkedIcon,
    },
});
export const errorCommonStyles = (FOUNDATIONS, FONT, STATE_TOKENS) => ({
    ...commonStateStyles(FOUNDATIONS, FONT, {
        ...STATE_TOKENS,
        checkbox: {
            border_color: FOUNDATIONS.color_feedback_error_border_50,
            ...STATE_TOKENS.checkbox,
        },
        checkedIcon: {
            color: FOUNDATIONS.color_feedback_error_icon_50,
            ...STATE_TOKENS.checkedIcon,
        },
    }),
});
export const disabledCommonStyles = (FOUNDATIONS, FONT, STATE_TOKENS) => ({
    ...commonStateStyles(FOUNDATIONS, FONT, {
        ...STATE_TOKENS,
        checkbox: {
            border_color: FOUNDATIONS.color_accent_disabled_border_100,
            background_color: FOUNDATIONS.color_accent_disabled_bg_100,
            cursor: 'default',
            ...STATE_TOKENS.checkbox,
        },
        checkedIcon: {
            color: FOUNDATIONS.color_accent_disabled_icon_50,
            ...STATE_TOKENS.checkedIcon,
        },
    }),
});
//# sourceMappingURL=commonStyles.js.map